import { useMemo } from 'react';
import { DateRange, mapByDateRanges } from 'utils/misc';
import { MappedHistoryItem } from 'types/AssistantTypes';
import { ThreadList } from './ThreadList';

interface GroupedThreadListsProps {
  threads: MappedHistoryItem[];
  updateDeletedThreads: (threadId: string) => void;
  sizeExpanded: number;
}

const GroupedThreadLists = ({ threads, updateDeletedThreads, sizeExpanded }: GroupedThreadListsProps) => {
  const threadGroups: Record<DateRange, MappedHistoryItem[]> = useMemo(() => {
    return mapByDateRanges(threads);
  }, [threads]);

  return (
    <div className="h-full space-y-8">
      {Object.keys(threadGroups).map((range) => (
        <ThreadList
          key={range}
          range={range as DateRange}
          threads={threadGroups[range]}
          onThreadDelete={updateDeletedThreads}
          sizeExpanded={sizeExpanded}
        />
      ))}
    </div>
  );
};

export default GroupedThreadLists;
